"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Div_1 = require("../Div");
const Root = (0, styled_1.default)(Div_1.Div)({
    gridArea: 'Body',
    padding: `0px ${constants_1.theme.spacing[3]}px ${constants_1.theme.spacing[2]}px`,
});
const Body = ({ grow = false, children, styles, }) => {
    const mergedStyles = {
        ...(grow
            ? { flex: 1 }
            : {
                minHeight: 60,
                overflowY: 'auto',
                maxHeight: '70vh',
            }),
        ...styles,
    };
    return (0, jsx_runtime_1.jsx)(Root, { styles: mergedStyles, children: children });
};
exports.Body = Body;
